import React from 'react';
import '../assets/layout.scss';
import logo_icon from "src/images/icon/amz-autos.svg";
import {NEW_TAB, CONDITIONS_OF_USE_URL, PRIVACY_NOTICE_URL} from "src/constants/Links";

export const Header: React.FC = () => {
    return (
        <header className="header">
            <img className="header-logo" src={logo_icon} />
        </header>
    );
};

interface BackButtonProps {
    onClick?: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
    const handleBackClick = () => {
        if (onClick) {
            onClick();
        } else {
            window.history.back();
        }
    };

    return (
        <button className="back-button" onClick={handleBackClick}>Back</button>
    );
};

export const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-row">
                <span className="footer-text">© 2025, Amazon.com Services LLC.</span>
                <span className="footer-links">
                    <a href={CONDITIONS_OF_USE_URL} className="footer-link" target={NEW_TAB} rel="noopener noreferrer">Conditions of Use</a>
                    &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                    <a href={PRIVACY_NOTICE_URL} className="footer-link" target={NEW_TAB} rel="noopener noreferrer">Privacy Notice</a>
                </span>
            </div>
        </footer>
    );
};